<mat-card>
    <div class="row">
        <prl-label value="label.dashboard.refer.friend"></prl-label>
        <mx-info-tooltip [config]="referFriendConfig"></mx-info-tooltip>
    </div>
    <hr/>
    <prl-label value="label.dashboard.refer.new"></prl-label>
    <prl-label value='label.dashboard.link'></prl-label>
    <div class="row">
        <a href="{{refererLink}}">{{refererLink}}</a>
        <mx-button [buttonModel]="copyButton"></mx-button>
    </div>
</mat-card>